import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'sonner';
import { queryClient } from './app/query-client';
import { router } from './app/router';
import { TooltipProvider } from './components/ui/misc';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delayDuration={400}>
        <RouterProvider router={router} />
        <Toaster position="bottom-left" richColors closeButton />
      </TooltipProvider>
    </QueryClientProvider>
  </StrictMode>,
);

// Auto-recover from stale chunks when a new deployment occurs
if (typeof window !== 'undefined') {
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    const key = 'qub_preload_reload';
    const last = sessionStorage.getItem(key);
    const now = Date.now();
    if (!last || now - parseInt(last, 10) > 10000) {
      sessionStorage.setItem(key, String(now));
      window.location.reload();
    }
  });
}

// Register PWA service worker on standard web browsers; disable in Android wrapper
const isAndroidApp = typeof navigator !== 'undefined' && /QubDocsAndroid/i.test(navigator.userAgent);
if ('serviceWorker' in navigator && import.meta.env.PROD && !isAndroidApp) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        console.log('[PWA] Service worker registered with scope:', reg.scope);
      })
      .catch((err) => {
        console.warn('[PWA] Service worker registration failed:', err);
      });
  });
} else if ('serviceWorker' in navigator && isAndroidApp) {
  // If an old service worker was registered by a previous session in the WebView, unregister it and clear cache
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister();
    }
  });
  if (typeof caches !== 'undefined') {
    caches.keys().then((names) => {
      for (const name of names) {
        caches.delete(name);
      }
    });
  }
}

